export default {
  vgn: {
    name: 'Vegaaninen',
    emoji: '🌱',
  },
  vgt: {
    name: 'Kasvisruoka',
    emoji: '🥬',
  },
  gf: {
    name: 'Gluteeniton',
  },
  df: {
    name: 'Maidoton',
  },
  hal: {
    name: 'Halal',
  },
  'h&s': {
    name: 'Tulinen',
    emoji: '🌶',
  },
};
